import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MdClose, MdError } from "react-icons/md";

const CustomAlert = ({ show, message, onClose, duration = 2000 }) => {
    useEffect(() => {
        if (show && duration > 0) {
            const timer = setTimeout(() => {
                onClose();
            }, duration);
            return () => clearTimeout(timer);
        }
    }, [show, duration, onClose]);

    return (
        <AnimatePresence>
            {show && (
                <motion.div
                    initial={{ opacity: 0, y: -50 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -50 }}
                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                    className="fixed top-0 left-0 right-0 z-50 mx-auto max-w-7xl px-6 pt-6"
                >
                    <div className="bg-red-50 border-2 border-red-600 rounded-lg shadow-lg">
                        <div className="p-4 flex items-start gap-3">
                            {/* Error Icon */}
                            <div className="flex-shrink-0">
                                <MdError className="text-red-600" size={24} />
                            </div>

                            {/* Message */}
                            <div className="flex-1 min-w-0">
                                <p className="text-red-800 text-sm leading-relaxed">
                                    {message}
                                </p>
                            </div>

                            {/* Close Button */}
                            <button
                                onClick={onClose}
                                className="flex-shrink-0 text-red-600 hover:bg-red-100 p-1 rounded transition-all"
                            >
                                <MdClose size={20} />
                            </button>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default CustomAlert;
